<script setup></script>

<template>
  <i
    class="info pi pi-info-circle"
    v-tooltip.top="{
      value:
        'Dieser Link führt zur Webseite der nebenstehenden Institution, da diese keine eigene Rechercheplattform besitzt.',
    }"
  />
</template>

<style lang="scss" scoped>
.info {
  font-size: 1.25em;
  margin-left: 0.5em;
  position: relative;
  bottom: -0.15em;
}
</style>
